<template>
  <el-dialog
    title="付款"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose">
    <div class="content">
      <div class="top">
        付款
      </div>
      <div class="bottom">
        <div class="orderInfo">
          <div class="baseInfo">
            {{orderInfo.consignee}}&emsp;&emsp;
            {{orderInfo.mobile}}<br />
            {{orderInfo.area}}
          </div>
          <div class="amount">应付金额：{{orderInfo.order_amount}}元</div>
        </div>
        <div class="payment">
          <div class="tabs">
            <div class="tab">微信支付({{countDown}})</div>
          </div>
          <div class="tabContent">
            <img src="../../assets/images/wechat.png" class="wecahtIcon"/>
            <label class="wechatText">微信支付</label>
            <div class="qrcode">
              <img class="qrcode" :src="qrcodeUrl"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { OrderService } from '../../service/order.service';
import qrcode from 'qrcode';
  export default {
    name: 'selectOrderWay',
    props: {
      orderInfo: {
        type: Object,
        default: () => ({}),
      }
    },
    data() {
      return {
        qrcodeUrl: '',
        dialogVisible: false,
        setInterval: null,
        statusInterval: null,
        countDown: 90,
      }
    },
    destroyed() {
      clearInterval(this.setInterval);
      clearInterval(this.statusInterval);
    },
    methods: {
      async open() {
        if (!this.qrcodeUrl) {
          this.createQrcode();
          this.setInterval = setInterval(() => {
            if (this.countDown - 1<= 0) {
              this.countDown = 90;
              this.createQrcode();
            } else {
              this.countDown--;
            }
          }, 1000);
          this.statusInterval = setInterval(() => {
            this.loadingOrderStatus();
          }, 2000);
        }
        this.dialogVisible = true;
      },
      async createQrcode() {
        const data = await OrderService.createQrcodeForWechat(this.orderInfo.order_sn, this.orderInfo.address_id);
        qrcode.toDataURL(data).then(url => {
          this.qrcodeUrl = url;
        });
      },
      async loadingOrderStatus() {
        const data = await OrderService.getOrderState(this.orderInfo.order_sn);
        if (data === 0) {
          clearInterval(this.setInterval);
          clearInterval(this.statusInterval);
          this.handleClose();
          this.$emit('success');
        }
      },
      handleClose() {
        this.dialogVisible = false;
      }
    },
  }
</script>

<style lang="scss" scoped>

.title {
  background: #2E98D5;
  width: 100%;
  color:  #fff;
}

/deep/ .el-dialog__header{
  // padding: 0;
  background: #2E98D5;
  color: #fff;
  .el-dialog__title {
    color: #fff;
    font-size: 14px;
  }
  i {
    color: #fff !important;
  }
}

.content {
  border: 1px solid #eee;
  border-radius: 14px;
  .top {
    border-bottom: 3px solid #2E98D5;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    color:  #2e98d5;
    font-weight: bold;
  }
  .bottom {
    padding: 20px;
    .orderInfo {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .amount {
        color: #2e98d5;
        font-size: 18px;
      }
    }
  }
}

.successIcon {
	border-radius: 50%;
	height: 100px;
	width: 100px;
	background: rgb(53, 187, 0);
	position: relative;
	margin-bottom: 20px;
  &::before {
    content: " ";
    height: 50px;
    width: 30px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -25px;
    margin-left: -15px;
    border-bottom: 6px solid #fff;
    border-right: 6px solid #fff;
    transform: rotate(45deg);
  }
}


.payment {
  margin-top: 20px;
  .tabs {
    display: flex;
    justify-content: flex-end;
    .tab {
      height: 40px;
      width: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid rgb(28, 238, 0);
      border-right: 1px solid rgb(28, 238, 0);
      border-left: 1px solid rgb(28, 238, 0);
      color: rgb(24, 189, 2);
      font-size: 18px;
      background: #fff;
      z-index: 3;
      position: relative;
      margin-bottom: -2px;
    }
  }
}
.tabContent {
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(28, 238, 0);
  .wechatText {
    margin: 0 26px;
    margin-right: 70px;
    font-size: 20px;
  }
  .qrcode {
    height: 180px;
    width: 180px;
    position: relative;
    &::before {
      content: '请使用微信扫一扫支付';
      bottom: -20px;
      left: 20px;
      position: absolute;
    }
  }
}
.wecahtIcon {
  height: 110px;
  width: 160px;
}


</style>